export function getTrainingSectionColor(slope: number): string {
  if (slope <= -2) return '#428FF3';
  if (slope <= 2) return '#57C063';
  if (slope <= 5) return '#FFD46C';
  if (slope <= 8) return '#FFA34F';
  return '#E55F58';
}
